import React from 'react';
import revampData from '../../data/revampData.json';
import { theme, websiteColors } from "../../themes/Theme.js";
const CaseStudiesIntro = () => {
  const sectionData = revampData.data.listCaseStudiesIntros.data[0];
  const {
    sectionTitle,
    subheading,
    heading,
    description,
    button
  } = sectionData;
  return <div className="event-section-container d-flex flex-column align-items-center font-figtree abstract-img px-sm-5 px-3 py-5" data-sentry-component="CaseStudiesIntro" data-sentry-source-file="CaseStudiesIntro.jsx">
      <div className='mb- text-center text-lg-center'>
        <h6 className="section-title">{sectionTitle}</h6>
        <h1 className="heading1">
          {heading} <br />
          {subheading}
        </h1>
        <p className="description mt-2">{description}</p>
      </div>
      <div>
        <div className='mt-3 mt-lg-3 d-flex justify-content-center justify-content-lg-start'>
          <a href={button.link} target='_blank' className="btn btn-primary join-button">
            <img src={button.icon} alt="" className="whatsapp-icon" />
            {button.text}
          </a>
        </div>
      </div>
      <style jsx>
        {`
          .event-section-container {
            text-align: left;
            // padding: 50px 60px;
          }
          .abstract-img {
            background-color: white;
            background-image: url('https://d2nnrpx7gk2my2.cloudfront.net/files/670455e0bd1102000878b17a/Abstract3DGridLandscape(1)1.svg');
            background-position: center;
            background-size: cover;
            background-repeat: no-repeat;
            height: 470px;
          }
          .section-title {
            font-size: 16px;
            font-weight: 600;
            line-height: 24px;
            letter-spacing: 2px;
            color: ${websiteColors[theme].primaryWebsiteTheme};
            text-transform: uppercase;
            margin-bottom: 10px;
          }
          .heading1, .heading2 {
            font-size: 36px;
            font-weight: 600;
            color: #001234;
            line-height: 44px;
            letter-spacing: 2px;
          }
          .description {
            font-size: 20px;
            font-weight: 400;
            line-height: 30px;
            max-width: 700px;
            color: #525252;
            margin-bottom: 30px;
          }
          .join-button {
            display: inline-flex;
            align-items: center;
            padding: 10px 40px;
            background-color: ${websiteColors[theme].primaryWebsiteTheme};
            color: white;
            gap: 10px;
            text-decoration: none;
            border-radius: 5px;
            box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.06);
            font-weight: 600;
            font-size: 16px;
            line-height: 28px;
            letter-spacing: 1px;
          }
          .whatsapp-icon {
            width: 20px;
            margin-right: 10px;
          }
          @media (max-width: 766px) {
            .heading1 {
              font-size: 32px;
            }
          }
          @media (max-width: 576px) {
            .join-button {
              width: 100%;
              padding: 10px 22px;
              justify-content: center;
              align-items: center;
            }
            .abstract-img {
              height: 530px;
            }
            .heading1 {
              letter-spacing:0px;
            }
            .abstract-img {
            background-color: white;
            background-image: url('https://d2nnrpx7gk2my2.cloudfront.net/files/6709030ea20d5d00085676c2/abstract_3d_grid_landscape_1_2.webp');
            height: 530px;
          }
          .description{
            letter-spacing:0px;
          }

          }
          @media (max-width: 429px) {
            .abstract-img {
              height: 570px;
            }
          }
          @media (max-width: 420px) {
            .abstract-img {
              height: 593px;
            }
          }
          @media (max-width: 365px) {
            .join-button {
              width: 100%;
              padding: 10px 2px;
              gap:0px !important;
            }
              
          }
        `}
      </style>
    </div>;
};
export default CaseStudiesIntro;